
<div ng-if="(loading && students.length > 0) || (loading && showAll)">
    <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <h2>
                <i class="fa fa-refresh fa-fw fa-spin"></i> Building table...
            </h2>
        </div>
    </div>
</div>

<div ng-if="(!loading && students.length > 0) || (!loading && showAll)">
    <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <legend>
                Table Results
                <span class="pull-right" ng-if="students.length > 0 || showAll">
                        <!--<i class="cursor-pointer fa fa-file-pdf-o fa-fw danger" ng-click="exportPDF()"></i>-->
<!--                    <i class="cursor-pointer fa fa-file-excel-o fa-fw success" ng-click="exportExcelAdvancedV2()"></i> -->
                    <!--<i class="cursor-pointer fa fa-file-text-o fa-fw primary" ng-click="exportCSV()"></i>-->
                </span>
            </legend>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" id="exportTable">
            <div class="table-responsive">
                <table class="table" id="gradeAgeAlignmentTable">
                    <tbody>
                        <tr>
                            <td class="bold text-center info black" colspan="27">Grade Level</td>
                        </tr>
                        <tr>
                            <td class="bold info black">Age on 9/1/{{schoolYear.current}}</td>
                            <td class="bold info black" ng-repeat="grade in grades">{{grade.GRADES}}</td>
                        </tr>
                        <tr *ngFor="let ageObj of table | objectToArrayPipe">
                            <ng-container *ngIf="ageObj[1]">
                                <td class="info black">{{ ageObj[0] }}</td>
                                <td *ngFor="let gradeEntry of ageObj[1] | keyvalue">
                                    <!-- HTML content using ageObj and gradeEntry -->
                               </td>
                            </ng-container>
                        </tr>
                        <tr>
                            <td class="info black">Total For Grade</td> 
                            <td *ngFor="let grade of gradeTotal | keyvalue">
                                <span *ngIf="showAll && gradeTotal[grade.key]?.COUNT > 0">{{gradeTotal[grade.key]?.COUNT}}</span>
                                <view-grade-intersect-btn #appViewGradeIntersectBtnComponent *ngIf="!showAll" count="gradeTotal[grade.key]?.COUNT" chosen-regions="chosenRegions" chosen-counties="chosenCounties" chosen-school-districts="chosenSchoolDistricts" chosen-schools="chosenSchools" school-year="schoolYear" grade="grade.key"></view-grade-intersect-btn> 
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3>Legend:</h3>
                <h5>Light gray cells - appropriate grade, or one year over or under age.</h5>
                <h5>Dark gray cells - more than one year over age.</h5>
                <h5>Orange cells - possible data errors.</h5>

            </div>
        </div>
    </div>
</div>